import declare from "dojo/_base/declare";
import { CallMethod } from "csi/xml/CallMethod";
import New from "csi/table/New";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";

const NewSizeCurveWizard = declare([New, ActionControllerMixin], {

	matrixPage: null,

	/**
	 * @override
	 * Disable finish button on first page
	 */
	disableFinish: function (wizard, page, index) {
		return index == 0;
	},

	/**
	 * @override
	 * Pass data into the next page
	 */
	onNextPage: function(wizard, currentPage, nextPage, bFinish) {
		const fd = this.m_formData;
		fd.m_bRequireOne = true;
		fd.m_bSelectOne = true;
		this.matrixPage = wizard.getPageAt(1);
		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, true) : null;
	},
	
	/**
	 * @override
	 * Add the matrix values to the call
	 */
	toWriterRequest: function () {
		const call = this.inherited<CallMethod>(arguments);
		const form = this.matrixPage.getView();
		const matrixValues = form.matrix.get("value").flat(1);
		call.addParameter("QuantityPerSize", "int"+xml.ATTR_LIST, matrixValues);
		return call;
	},
});


export = NewSizeCurveWizard;